<script lang="ts">
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import type { SellSheet } from "@shared/types/SellSheet";
  import productContainerDetails from "@shared/filters/product_container_details.js";
  export let sellSheet: SellSheet;
  export let showProductLinks = false;
  export const user = sellSheet.user;
  export const distributor = sellSheet.distributor;
  const arrayCleanup = input => input.toString().replace(/,/gi, ", ");
</script>

<PageWrapper let:mobileMode>
  <div class="grid-container">
    <!-- NAME -->
    <div
      class="grid-row padding-left--small padding-right--small padding-bottom--small padding-bottom--medium--md"
    >
      <div class="grid-col c12-12 align-center">
        <div
          class="default-headline--regular--md default-title--bold margin-top--small padding-top--small--md wrap-text"
        >
          {sellSheet.name}
        </div>
      </div>
    </div>
    <!-- REP CONTACT INFO -->
    <div class="grid-row">
      <div class="grid-col c12-12 background-white padding--small sell-sheet-preview-wrapper">
        <div class="grid-row">
          <div class="grid-col c8-12--md c12-12">
            <div class="default-subheader--bold">{distributor.name}</div>
            <div class="default-subheader--regular">{user.first_name} {user.last_name}</div>
            <div class="default-subheader--bold color-brandSecondary">
              {#if user.phone}
                <a href="tel:{user.phone}">{user.phone || ""}</a><span
                  class="color-black default-body--regular"
                  >,
                </span>
              {/if}
              <a href="mailto:{user.email}">{user.email}</a>
            </div>
          </div>
          {#if distributor.cloudinary_image_url}
            <div class="grid-col c4-12--md align-right show--md">
              <div class="media margin-left--small float-right">
                <ProductImage
                  width={180}
                  height={100}
                  product={{ cloudinary_image_url: distributor.cloudinary_image_url }}
                  className={"vertical-align-text-top media-fixed distributors-image"}
                />
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
    <div class="grid-row"><hr class="hr hr-card-separator" /></div>
    {#if sellSheet.notes}
      <div class="grid-row">
        <div class="grid-col c12-12 background-white padding--small sell-sheet-preview-wrapper">
          <span class="default-subheader--bold" style="display: block;">Notes:</span>
          <span class="default-subheader--regular wrap-text" style="white-space: pre-wrap;"
            >{sellSheet.notes}</span
          >
        </div>
      </div>
    {/if}

    <!-- PRODUCTS -->
    <div class="grid-row"><hr class="hr hr-card-separator" /></div>


    {#if sellSheet.product_lines.length > 0}
      <div class="grid-row margin-bottom--small">
        {#each sellSheet.product_lines as productLine, i}
          <div
            class="grid-col c12-12 align-left background-white dpl-row sell-sheet-preview-wrapper"
            id="product-line-{productLine.id}"
          >
          <div class="grid-row padding--small fizz-styles">
            <div class="media">
              <ProductImage
                width={80}
                height={80}
                product={productLine}
                className={"media-fixed distributors__inventory-image margin-right--small"}
              />

              <div class="media-fluid align-self-center">
                <div class="default-subheader--bold">
                  {#if showProductLinks}
                    <UIRouterLink stateName='layout.product_detail'
                      params={{
                        productId: productLine.cloned_from_product_line_id,
                        ssplId: productLine.id,
                        shareId: sellSheet.share_id,
                      }}
                      classes={"color-brandPrimary underline-hover cursor-pointer"}
                    >
                      {productLine.name}
                    </UIRouterLink>
                  {:else}
                    {productLine.name}
                  {/if}
                </div>
                {#if productLine.abv}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">ABV: </span>{productLine.abv}%
                  </div>
                {/if}
                {#if productLine.manufacturer}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">Manufacturer: </span>{productLine.manufacturer}
                  </div>
                {/if}

                {#if productLine.category}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">Type: </span>{productLine.category}
                  </div>
                {/if}

                {#if productLine.product_type_name == "Wine"}
                  {#if productLine.vintage_years}
                    <div class="default-body--regular margin-top--smallest">
                      <span class="strong">Vintage Years: </span>{arrayCleanup(productLine.vintage_years)}
                    </div>
                  {/if}
                  {#if productLine.wine_appellation}
                    <div class="default-body--regular margin-top--smallest">
                      <span class="strong">Wine Appellation: </span>{productLine.wine_appellation}
                    </div>
                  {/if}
                  {#if productLine.wine_region}
                    <div class="default-body--regular margin-top--smallest">
                      <span class="strong">Wine Region: </span>{productLine.wine_region}
                    </div>
                  {/if}
                  {#if productLine.wine_varietal}
                    <div class="default-body--regular margin-top--smallest">
                      <span class="strong">Wine Varietal: </span>{productLine.wine_varietal}
                    </div>
                  {/if}
                {/if}

                {#if productLine.description}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">Description: </span>
                    <div style="white-space: pre-wrap;">{productLine.description}</div>
                  </div>
                {/if}
                {#if productLine.tasting_notes}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">Tasting Notes: </span>
                    <div style="white-space: pre-wrap;">{productLine.tasting_notes}</div>
                  </div>
                {/if}
                {#if productLine.additional_notes}
                  <div class="default-body--regular margin-top--smallest">
                    <span class="default-body--bold">Additional Notes: </span>
                    <div style="white-space: pre-wrap;">{productLine.additional_notes}</div>
                  </div>
                {/if}
                {#if productLine.sell_sheet_products_attributes.length}
                  <div class="s5 margin-top--smallest">
                    <span class="default-body--bold">Available Sizes: </span>
                    {#each productLine.sell_sheet_products_attributes as product, i}
                      <div class='padding-bottom--small'>
                        <span class="">Size: </span>{productContainerDetails()(product)}
                        {#if product.unit_price || product.case_price}
                          <div>
                            <span class="">Price: </span>
                            {#if product.unit_price}
                              <span>${product.unit_price}/unit</span>
                            {/if}
                            {#if product.case_price}
                              <span>
                                {#if product.unit_price}
                                  <span> - </span>
                                {/if}${product.case_price}/case
                              </span>
                            {/if}
                            {#if productLine.sell_sheet_products_attributes.length != (i + 1)}
                              <span>,</span>
                            {/if}
                          </div>
                        {/if}
                        {#if product.case_quantity || product.unit_quantity}
                          <div class="s5">
                            <span class="">Suggested Quantities:</span>
                            {#if product.unit_quantity}
                              {product.unit_quantity}
                              {product.container_type}{#if product.unit_quantity !== 1}s{/if}
                            {/if}
                            {#if product.case_quantity}
                              {#if product.unit_quantity}, {/if}
                              {product.case_quantity} case{#if product.case_quantity !== 1}s{/if}
                            {/if}
                          </div>
                        {/if}
                        </div>
                    {/each}
                  </div>
                {/if}
              </div>
              <!-- Desktop View Product Buttons -->
              {#if !mobileMode}
                <div class="show--md">
                  <div class="media-fixed align-right secondary-body--bold fizz-styles">
                    <button class="fizz-button-primary button--primary button--disabled-view-only">View Product</button>
                  </div>
                </div>
              {/if}
            </div>
          </div>
          <div class="grid-row"><hr class="hr hr-card-separator" /></div>
          </div>
        {/each}
      </div>
    {/if}

  </div>
</PageWrapper>
